import { jsx } from 'react/jsx-runtime';
import { useContext } from 'react';
import { SkeletonBox } from '../../SkeletonBox/SkeletonBox.es.js';
import { NumberBoxContext } from '../NumberBox.Context/NumberBox.Context.es.js';

const NumberBoxTitle = ({ as: DynamicTag = 'h2', children })=>{
    const { loading } = useContext(NumberBoxContext);
    return jsx(DynamicTag, {
        className: "title",
        children: jsx(SkeletonBox, {
            className: "loading",
            loading: loading,
            children: children
        })
    });
};
NumberBoxTitle.displayName = 'NumberBox.Title';

export { NumberBoxTitle };
//# sourceMappingURL=NumberBox.Title.es.js.map
